import { EventEmitter, Injectable } from '@angular/core';
import {ParentService} from '../A2-utils/ParentClass/ParentService';
import { Router } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { constant } from '../../app.constants';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class ActionsService extends ParentService {
  onAddNewAction$ = new EventEmitter<boolean>();
  actionId = new BehaviorSubject<number>(null);
  save = new BehaviorSubject<boolean>(false);
  actionId$ = this.actionId.asObservable();
  save$ = this.save.asObservable();

  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }

  /**
   * @name deleteData
   * @description
   * @param data
   */
  deleteData(data: any) {
    return this._http
      .delete(`${constant.URL_ACTION}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getActionByID
   * @description
   * @param id
   */
  getActionByID(id: number) {
    return this._http
      .get(constant.URL_ACTION + '/' + id, this.getHeader())
      .map(res => res.json(), this.getHeader());
  }

  /**
   * @name getActions
   * @description
   */
  getActions() {
    return this._http
      .get(constant.URL_ACTION, this.getHeader())
      .map(res => res.json(), this.getHeader());
  }

  /**
   * @name postData
   * @description
   * @param data
   */
  postData(data: any) {
    const bodyString = JSON.stringify(data);

    return this._http
      .post(constant.URL_ACTION, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putData
   * @description
   * @param data
   */
  putData(data: any) {
    const bodyString = JSON.stringify(data);

    return this._http
      .put(constant.URL_ACTION, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/actions/actions.service.ts